import * as React from 'react';

function SvgWalletAccount(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path d="M0 0h24v24H0z" fill="none" />
      <g data-name="wallet_account">
        <path
          d="M22.186 6.11a3.1 3.1 0 00-3.1-3.105L4.112 3a3.1 3.1 0 00-3.1 3.1v11.394a3.108 3.108 0 003.1 3.105l14.974.005a3.1 3.1 0 003.105-3.1zm-4.748 6.732a2.908 2.908 0 000-2.074h2.675v2.074zm-3.953-1.038a1.037 1.037 0 111.037 1.037 1.038 1.038 0 01-1.037-1.037zm5.593 6.732l-14.974-.005a1.035 1.035 0 01-1.033-1.034V6.103A1.033 1.033 0 014.104 5.07l14.974.005a1.034 1.034 0 011.033 1.034v2.589H14.52a1.046 1.046 0 00-.209.021 3.092 3.092 0 000 6.173 1.036 1.036 0 00.209.021h5.591v2.589a1.034 1.034 0 01-1.034 1.033z"
          data-name="Path 4305"
        />
      </g>
    </svg>
  );
}

export default SvgWalletAccount;
